/**
 * Caché del catálogo del POS para Fase 1 (offline).
 *
 * Guarda el último catálogo cargado ONLINE por sucursal en localStorage, para
 * poder pintar los productos aunque no haya red. Es una copia de conveniencia:
 * el precio/stock reales se reconfirman al reconectar (y el backend siempre
 * recalcula el dinero al cobrar). Fail-soft: cualquier error de storage se
 * ignora (el POS sigue funcionando online).
 */

const keyFor = (branchId) => `pos_catalog_${branchId}`

export const saveCatalog = (branchId, catalog) => {
  if (!branchId || !catalog) return
  try {
    localStorage.setItem(keyFor(branchId), JSON.stringify({ at: Date.now(), catalog }))
  } catch (e) {
    // Sin espacio / storage deshabilitado: el offline simplemente no tendrá caché.
  }
}

/** Devuelve { at, catalog } o null. */
export const loadCatalog = (branchId) => {
  if (!branchId) return null
  try {
    const raw = localStorage.getItem(keyFor(branchId))
    if (!raw) return null
    const parsed = JSON.parse(raw)
    return parsed && parsed.catalog ? parsed : null
  } catch (e) {
    return null
  }
}
